document.addEventListener('DOMContentLoaded', function() {
    const dataLayoutTabs = document.querySelector('[data-layout="tabs"]');
    const tabs = document.querySelectorAll('.nav-tabs .nav-link');
    const indicator = document.querySelector('.tab-indicator');

    function updateIndicator(tab) {
        const tabRect = tab.getBoundingClientRect();
        const parentRect = tab.closest('.nav-tabs').getBoundingClientRect();
        const left = tabRect.left - parentRect.left;
        const width = tabRect.width;

        indicator.style.width = `${width}px`;
        indicator.style.left = `${left}px`;
    }

    if (dataLayoutTabs) {
        tabs.forEach(tab => {
            tab.addEventListener('shown.bs.tab', function() {
                updateIndicator(tab);
            });
        });

        // Initialize indicator position
        updateIndicator(document.querySelector('.nav-tabs .nav-link.active'));
    }
    
    // Ensure indicator updates on window resize
    window.addEventListener('resize', () => {
        if (dataLayoutTabs) {
            updateIndicator(document.querySelector('.nav-tabs .nav-link.active'));
        }
    });
});

